import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=fb33c0cc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=fb33c0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33c0cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb33c0cc')) {
      api.createRecord('fb33c0cc', component.options)
    } else {
      api.reload('fb33c0cc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=fb33c0cc&scoped=true&", function () {
      api.rerender('fb33c0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l7sudHhlg5p9/JS/comp/GuestBox.vue"
export default component.exports